<template>
  <Row class-name="bodys">
    <Col span="24">
    <Breadcrumb separator=">">
      <BreadcrumbItem :to="{
        name: 'notice'
      }">
        征集公告
      </BreadcrumbItem>
      <BreadcrumbItem>内容</BreadcrumbItem>
    </Breadcrumb>
    </Col>
    <Col span="24">
    <Spin fix v-if="loading" />
    <template v-else>
      <p class="title">{{ date.title }}</p>
      <p class="vice">发布时间：{{ date.date }}</p>
      <div class="editor content" v-html="date.content"></div>
    </template>
    </Col>
  </Row>
</template>

<script>
import { GetNewsinfoDetail } from '@api'
export default {
  name: 'news-content',
  data() {
    return {
      date: {},
      loading: false,
      infoId: '',
      type: ''
    }
  },
  computed: {
  },
  mounted() {
    const { type, id } = this.$route.query
    this.infoId = id
    this.type = type
    this.getContent()
  },
  methods: {
    // 处理转义字符
    handleEscapeChar(str) {
      const ESCAPE_CHARACTERS = {
        'nbsp': ' ',
        'lt': '<',
        'gt': '>',
        'amp': '&',
        'apos': '\"',
        'ensp': '	 ',
        'emsp': ' ',
        'quot': '"',
        'middot': '·',
        'brvbar': '¦',
        'mdash': '—',
        'ndash': '–',
        'ge': '≥',
        'le': '≤',
        'laquo': '«',
        'raquo': '»',
        'deg': '°',
        'bull': '•',
        'macr': '¯',
        '#64': '@',
        'ldquo': '“',
        'rdquo': '”',
        'rsquo': '‚',
        'lsquo': '‘',
      }
      return str.replace(new RegExp(`&(${Object.keys(ESCAPE_CHARACTERS).join('|')});`, 'g'), (all, t) => {
        return ESCAPE_CHARACTERS[t]
      })
    },
    async getContent() {
      this.loading = true
      try {
        const query = { ID: this.infoId }
        const { data: { NewsTitle, NewsDateTime, NewNote } } = await GetNewsinfoDetail(query)
        console.log(NewsTitle);
        this.date = {
          title: NewsTitle,
          date: NewsDateTime.replace("+", " "),
          content: this.handleEscapeChar(NewNote.replace(/\+/g, " ")),
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
// @import '@theme/globle.scss';
.bodys {
  background: #fff;
  padding: 16px;
  // border-top: 2px solid $default;
  min-height: calc(100% - 235px);
}

.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  // @media screen and (max-width: $xs) {
  //   font-size: 18px;
  // }
}

.vice {
  text-align: center;
  font-size: 12px;
  margin: 25px 0;
}

.content {
  font-size: 16px;
}

.ivu-breadcrumb {
  border-bottom: 1px solid #e8e8e8;
}
</style>
